import { useMutation, useQuery } from 'react-query'
import request from '../request'

export const useAuthGenerateTwoFactorToken = () => {
  return useQuery(
    ['auth', 'generate-two-factor-token'],
    async () =>
      request({
        url: '/auth/two-factor/generate-token',
        method: 'GET',
      }).then((res: any) => res.data),
    {
      refetchInterval: 30 * 1000,
      refetchOnWindowFocus: false,
    },
  )
}
